import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ReadLandingPageDomain } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';

export type CheckLandingPageDomainParams = {
  organizationId: string;
};

export const checkLandingPageDomain = async (
  params: CheckLandingPageDomainParams,
): Promise<ReadLandingPageDomain> => {
  return await tinctApi.landingPageDomain.checkLandingPageDomain(
    params.organizationId,
  );
};

/**
 * Advance domain provisioning now instead of waiting for the ~2-min
 * server poller. 400 if no domain is registered.
 */
export const useCheckLandingPageDomain = (
  options?: Omit<
    UseMutationOptions<
      ReadLandingPageDomain,
      ApiError,
      CheckLandingPageDomainParams
    >,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: checkLandingPageDomain,
    onSuccess: (...args) => {
      // The check returns the fresh resource — publish it straight to the cache.
      queryClient.setQueryData(
        ['landing-page-domain', args[1].organizationId],
        args[0],
      );
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
